import React from 'react';
import { FormattedMessage } from 'react-intl';
import * as _ from 'lodash';


const pStyle = {
    fontSize: 36,
    letterSpacing: '-0.62px',
    color: '#000000',
    margin: '50px 0px 40px 0px',
    fontFamily: 'NotoSans-Light'
};

const Headline = props => (
    <div style={(props.styles && _.isPlainObject(props.styles)) ? _.defaults(props.styles, pStyle) : pStyle} >
        <div style={{marginLeft: 10}}>
            <FormattedMessage
                id={props.id}
                defaultMessage={props.defaultMessage}
            />
        </div>
        {
            !props.isNoLine ?
                <hr style={{ border: '0.5px solid #ebebeb', marginTop:30 }}/> : null
        }
    </div>
);

export default Headline
